module.exports = __webpack_public_path__ + "static/media/aston.c87fce5c.jpg";